import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound, {
	LazyNotFoundErrorPage,
} from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { errorsNotFoundRoute } from '@atlassian/jira-router-routes-errors-not-found-routes/src/errorsNotFoundRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const errorsNotFoundRouteEntry: Route = createEntry(errorsNotFoundRoute, () => ({
	group: 'errors',
	component: ErrorPagesNotFound,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazyNotFoundErrorPage],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-errors-not-found-entries/src/errorsNotFoundRouteEntry.tsx',
			whichExportToUse: 'errorsNotFoundRouteEntry',
		},

		enabled: true,
	},
}));
